module.exports = __webpack_public_path__ + "img/download.e6a14eb9.svg";